// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
// import * as ReactDOM from 'react-dom/client';

import { ApplicationLoader } from "../ApplicationLoader";

export type ApplicationViewProps = {
	/** */
	scope: "content" | "header" | "footer";

	/** */
	component: string;

	/** */
	// container: React.MutableRefObject<HTMLElement>;
};

export type ApplicationViewType = React.ComponentType<ApplicationViewProps>;

// Résolution statique des vues internes du shell. Un import() avec variable sans
// extension dans la partie statique n'est pas analysable par Vite : il n'est pas
// bundlé et finit résolu au runtime en URL relative (../../views/Home →
// /app/views/Home), donc fetché comme micro-front externe inexistant → 502 en
// prod. import.meta.glob force Vite à bundler ../../views/* dans le shell.
const views = import.meta.glob([
	"../../views/*.tsx",
	"../../views/*/index.ts",
]);

export const ApplicationView: ApplicationViewType = (
	props: ApplicationViewProps,
) => {
	const {
		scope,
		component,
		// container,
	} = props;

	const Component = React.lazy(
		(views[`../../views/${component}.tsx`] ??
			views[`../../views/${component}/index.ts`]) as () => Promise<{
			default: React.ComponentType;
		}>,
	);

	const view = (
		<React.Suspense
			fallback={<ApplicationLoader type={scope === "content" && "overlay"} />}
		>
			<Component />
		</React.Suspense>
	);

	// React.useEffect(() => {
	//   const root = ReactDOM.createRoot(container.current);

	//   root.render(view);

	//   return () => {
	//     root.unmount();
	//   };
	// }, [view]);

	return view;
};
